import React, { useEffect, useState } from 'react';
import { getFilteredCategoryContent } from '../../../Utils/helper';
import { storeDataFetcher } from '../../../datafetchers/Store';
import CartOverlayContainer from '../../CartOverlayContainer';
import StoreHeaderNew from '../../NewStoreHomeWeb/StoreHeaderNew/StoreHeaderNew';

export default function NewHeader(props) {
  const {
    categoryData,
    addedToCart,
    showCart,
    location,
    hideMobileSearch,
    showHeader,
    setAddedToCart,
    offerList,
    setCloseCart,
    hideCompleteHeader,
    orderSuccessHeader,
    showShopCta,
    stage,
    showNewHeader,
    babyCareProduct,
    userType,
    store,
    nostrip,
    productId,
    setIsCartOpen,
    isForNewCdPage,
    isForJoyfulPage,
    showSsoTooltipDot,
    loginPopUp,
    setLoginPopUp,
  } = props;
  const [categoryDataForTools, setDataForTools] = useState(null);
  useEffect(() => {
    const setCategoryData = async () => {
      if (!categoryData) {
        const data = await storeDataFetcher({
          skip: 0,
          limit: 10,
          lang: 'en',
          inApp: false,
          desktopView: true,
          key: 'store',
        });
        setDataForTools(getFilteredCategoryContent(data?.data?.categories));
      }
    };

    setCategoryData();
  }, []);
  return (
    <>
      <StoreHeaderNew
        hideMobileSearch={hideMobileSearch}
        orderSuccessHeader={orderSuccessHeader}
        categoryData={categoryData || categoryDataForTools}
        showCart={showCart}
        addedToCart={addedToCart}
        setAddedToCart={setAddedToCart}
        showHeader={showHeader}
        hideCompleteHeader={hideCompleteHeader}
        location={location}
        showShopCta={showShopCta}
        stage={stage}
        showNewHeader={showNewHeader}
        babyCareProduct={babyCareProduct}
        userType={userType}
        store={store}
        nostrip={nostrip}
        productId={productId}
        isForNewCdPage={isForNewCdPage}
        isForJoyfulPage={isForJoyfulPage}
        showSsoTooltipDot={showSsoTooltipDot}
        loginPopUp={loginPopUp}
        setLoginPopUp={setLoginPopUp}
      />

      <CartOverlayContainer
        setAddedToCart={setAddedToCart}
        offerList={offerList}
        setCloseCart={setCloseCart}
        setIsCartOpen={setIsCartOpen}
      />
    </>
  );
}
